import { AnalyticsBrowser } from '@segment/analytics-next'
import type { Analytics } from '@segment/analytics-next'

export const intercomIntegrationsDisabled = { Intercom: false, 'Intercom Web (Actions)': false }

/**
 * Loads analytics without the browser Intercom destination. The app owns Messenger.
 * @param {string} writeKey The Segment source write key.
 * @param {Record<string, boolean>} integrations The existing destination selection.
 * @returns {Promise<Analytics>}
 */
export async function loadSegment(writeKey: string, integrations: Record<string, boolean>): Promise<Analytics> {
  const [analytics] = await AnalyticsBrowser.load(
    { writeKey },
    { integrations: { ...integrations, ...intercomIntegrationsDisabled } }
  )
  return analytics
}
